module.exports = __webpack_public_path__ + "assets/ec3290f1c6946562684fc8ee869d4929.mp3";